import React from "react";
import { Layout, Menu } from "antd";
import {
	HomeOutlined,
	CalendarOutlined,
	FileAddOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { isOfficeSanctuaryUser } from "../rentSanctuaryUtils";

const { Sider } = Layout;

const RentSanctuaryNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const canManage = isOfficeSanctuaryUser();

	const menuItems = [
		{
			key: "/utils/rent-sanctuary/view-rental-sanctuary-schedule",
			icon: <CalendarOutlined />,
			label: "성전 대여 일정",
		},
		{
			key: "/utils/rent-sanctuary/view-rent-application",
			icon: <CalendarOutlined />,
			label: "성전 대여 신청 관리",
		},
		...(canManage
			? [
					{
						key: "/utils/rent-sanctuary/bulk-rent-schedule",
						icon: <FileAddOutlined />,
						label: "성전 대여 일괄 등록",
					},
				]
			: []),
	];

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	// Get the current selected key based on the current path
	const getSelectedKey = () => {
		const path = location.pathname;
		const menuItem = menuItems.find((item) => item.key === path);
		return menuItem ? menuItem.key : "/utils/rent-sanctuary/view-rent-application";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<HomeOutlined />
				<span>성전 대여 관리</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default RentSanctuaryNavigation;
